import axios, { AxiosError, AxiosResponse } from 'axios';
import { replaceUrlParams } from 'components/employee-portal/travel-arrangements/utils';
import showError from 'components/shared/showError';
import showSnackbar, { showErrorSnackbar } from 'components/shared/Snackbar';
import i18n from 'config/i18n';
import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { COSTCENTER_DETAILS } from 'RestAPIs/endpoints';
import { PlanUnitDetails as PlanUnitDetailsType } from 'components/types';

const useSavePlanUnitDetails = (
  params: {
    planUnitId: number;
    referenceDate: string;
  },
  message?: {
    success: string;
    error: string;
  },
  invalidateQueryKey?: string | unknown[]
) => {
  const update = useCallback(
    (data) => {
      const url = replaceUrlParams(COSTCENTER_DETAILS, {
        costCenterId: params.planUnitId,
        referenceDate: params.referenceDate
      });

      return axios.put(url, data);
    },
    [params]
  );

  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, PlanUnitDetailsType>(update, {
    onSuccess: async (response) => {
      showSnackbar({
        severity: 'success',
        message: message?.success ?? i18n.t('changesSaved')
      });

      if (invalidateQueryKey) {
        await queryClient.invalidateQueries({
          queryKey: invalidateQueryKey
        });
      }

      return response;
    },
    onError: (error) => {
      message?.error ? showErrorSnackbar(message.error) : showError(error);
    }
  });
};

export default useSavePlanUnitDetails;
